// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5582) return "static/chunks/5582-96191fabe557a36c.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1817":"182fbb577dd7c8fa","3391":"9316cea2c1c62892","4031":"ab55ee28b65d8af7","5259":"4ce2f62cf5717666","5892":"79625ddd794a67f1","6356":"151e585744263cd3","7516":"697cb8084fbe8035","8543":"757d4151a65888c6","9585":"4431f1a8f7f68360","9690":"9cf754726feabdb0"}[chunkId] + ".js";
};